if (!customElements.get('cards-peek-slider')) {
  class CardsPeekSlider extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
      this.splide = null;
    }

    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.init();
    }

    init() {
      if (typeof window.Splide !== 'undefined') {
        this.mountSlider();
        return;
      }

      const checkInterval = window.setInterval(() => {
        if (typeof window.Splide !== 'undefined') {
          window.clearInterval(checkInterval);
          this.mountSlider();
        }
      }, 100);

      window.setTimeout(() => {
        window.clearInterval(checkInterval);
      }, 10000);
    }

    mountSlider() {
      const slider = this.querySelector('[data-cards-peek-slider]');
      if (!slider || slider.dataset.sliderMounted === 'true') return;

      const totalSlides = slider.querySelectorAll('.splide__slide').length;
      if (!totalSlides) return;

      const hasMultipleSlides = totalSlides > 1;
      const hideDesktopArrows = totalSlides === 3;
      const hideDesktopPagination = totalSlides === 3;
      const fitDesktopThreeCards = totalSlides === 3;
      const showArrows = hasMultipleSlides && !hideDesktopArrows;
      slider.dataset.sliderMounted = 'true';

      const splide = new Splide(slider, {
        type: 'slide',
        arrows: showArrows,
        pagination: hasMultipleSlides && !hideDesktopPagination,
        drag: hasMultipleSlides,
        rewind: false,
        speed: 500,
        easing: 'cubic-bezier(0.25, 1, 0.5, 1)',
        gap: '24px',
        perMove: 1,
        perPage: fitDesktopThreeCards ? 3 : 1,
        flickMaxPages: 1,
        updateOnMove: true,
        fixedWidth: fitDesktopThreeCards ? false : '502px',
        padding: {
          left: '0px',
          right: hasMultipleSlides && !hideDesktopArrows && !fitDesktopThreeCards ? '120px' : '0px',
        },
        classes: {
          arrows: 'splide__arrows cards-peek-slider__arrows',
          arrow: 'splide__arrow cards-peek-slider__arrow',
          prev: 'splide__arrow--prev cards-peek-slider__arrow cards-peek-slider__arrow--prev',
          next: 'splide__arrow--next cards-peek-slider__arrow cards-peek-slider__arrow--next',
          pagination: 'splide__pagination cards-peek-slider__pagination',
          page: 'splide__pagination__page cards-peek-slider__pagination-dot',
        },
        breakpoints: {
          1023: {
            pagination: hasMultipleSlides,
            perPage: 1,
            fixedWidth: '420px',
            padding: {
              left: '0px',
              right: hasMultipleSlides && !hideDesktopArrows && !fitDesktopThreeCards ? '72px' : '0px',
            },
          },
          767: {
            pagination: hasMultipleSlides,
            gap: '16px',
            fixedWidth: false,
            perPage: 1,
            padding: {
              left: '0px',
              right: hasMultipleSlides ? '8%' : '0px',
            },
          },
        },
      });

      if (hasMultipleSlides) {
        splide.on('arrows:mounted', (prev, next) => {
          const arrowIcon = `
            <span class="cards-peek-slider__arrow-icon" aria-hidden="true">
              <svg viewBox="0 0 27 17" xmlns="http://www.w3.org/2000/svg">
                <path d="M26.667 9.81849L26.6672 7.15196H5.10467L10.3709 1.88561L8.48534 0L0 8.48529L8.48534 16.9706L10.3709 15.0849L5.10453 9.81863L26.667 9.81849Z" />
              </svg>
            </span>
          `;

          if (prev) {
            prev.innerHTML = arrowIcon;
            prev.setAttribute('aria-label', 'Previous slide');
          }

          if (next) {
            next.innerHTML = arrowIcon;
            next.setAttribute('aria-label', 'Next slide');
          }
        });

        splide.on('pagination:mounted', (data) => {
          data.items.forEach((item, index) => {
            item.button.innerHTML = `
              <span class="cards-peek-slider__pagination-icon" aria-hidden="true">
                <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.5 0L15.5 7.5L23 11.5L15.5 15.5L11.5 23L7.5 15.5L0 11.5L7.5 7.5L11.5 0Z" fill="white"/>
                </svg>
              </span>
            `;
            item.button.setAttribute('aria-label', `Go to slide ${index + 1}`);
          });
        });
      }

      splide.mount();
      this.splide = splide;
    }
  }

  customElements.define('cards-peek-slider', CardsPeekSlider);
}
